import { graphql } from 'relay-runtime';

export const UNIFIED_GAMIFICATION_MUTATION = graphql`
  mutation UnifiedGamificationMutation(
    $aaid: String!
    $comment: String!
    $value: Int!
  ) {
    unified {
      gamification {
        sendRecognition(comment: $comment, value: $value, receiverId: $aaid) {
          message
          success
          errors {
            code
            message
          }
        }
      }
    }
  }
`;
